export default __webpack_public_path__ + "static/media/or-lavie.f6422509.png";